import styled from 'styled-components';

const PartnerSectionWrapper = styled.section`
  .service-btn {
    background: #000;
    color: #fff;
    font-weight: 600;
    border-radius: 0;
  }

  .service-btn:hover {
    box-shadow: 0 0 1px 1px #fff;
  }
  .swiper-wrapper {
    margin-bottom: 20px;
    transition-duration: 3000ms !important;
  }
  .swiper-pagination {
    bottom: 0;

    @media (min-width: 992px) {
      text-align: left;
      margin-left: 180px;
    }

    .swiper-pagination-bullet {
      height: 12px;
      width: 12px;
    }

    .swiper-pagination-bullet-active {
      --swiper-theme-color: #000;
    }
  }

  .swiper-button-next {
    --swiper-theme-color: #000;
  }

  .swiper-button-prev {
    --swiper-theme-color: #000;
  }

  .swipe-content {
    display: flex;
    flex-wrap: wrap;

    .img {
      img {
        width: 100%;
      }
    }
  }
`;

export const FloatContent = styled.div`
  background: #fff;
  z-index: 1;
  color: #000;
  width: 1000px;
  margin: 20px auto;
  position: absolute;
  left: 0;
  right: 0;
  padding: 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  .main {
    display: flex;
  }
  .text-content {
    display: flex;

    align-items: center;
    padding: 20px;
    text-align: center;
    width: 100%;
    div {
      width: 100%;

      ul {
        margin: 0 20px;
        background: #000;
        padding: 10px;
        li {
          font-size: 17px;
          font-weight: 600;
          text-align: left;
          padding: 15px;
          color: #fff;

          svg {
            margin-top: -3px;
          }
        }

        li.active {
          background: #fff;
          color: #000;
          border-radius: 3px;
        }
      }
    }
  }
`;

export const AboutBox = styled.div`
  position: relative;
  background: #000;
  padding: 30px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  height: auto;
  margin-bottom: 20px;

  @media (min-width: 992px) {
    margin-bottom: 100px;
    height: 550px;
  }

  @media (min-width: 1200px) {
    height: 500px;
  }

  @media (min-width: 1440px) {
    height: 530px;
  }

  .title {
    font-size: 22px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 20px;
    text-align: center;

    @media (min-width: 992px) {
      font-size: 38px;
    }
  }

  .title-sub {
    color: #fff;
    margin-bottom: 20px;
    font-size: 12px;
    text-align: center;
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }

  .over-box {
    position: relative;
    background: #fff;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    padding: 10px;

    @media (min-width: 992px) {
      padding: 20px;
    }
    display: flex;
    flex-wrap: wrap;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

    @media (min-width: 576px) {
    }

    @media (min-width: 768px) {
    }

    @media (min-width: 992px) {
      position: absolute;
      width: 90%;
    }

    @media (min-width: 1200px) {
      width: 85%;
    }

    @media (min-width: 1440px) {
      width: 75%;
    }

    .col {
      flex-grow: 1;
      flex-basis: 0;
    }

    img {
      width: 100%;
      min-width: 100%;

      @media (min-width: 992px) {
        min-width: 300px;
      }
    }

    .content {
      min-width: 101%;
      padding: 10px;
      @media (min-width: 992px) {
        min-width: 300px;
        padding: 40px;
      }

      .sub-title {
        font-weight: 500;
        font-size: 22px;
        text-align: center;
        margin-bottom: 20px;

        @media (min-width: 992px) {
          font-size: 32px;
          margin-bottom: 30px;
        }
      }

      .desc {
        font-size: 12px;
        margin-bottom: 15px;

        @media (min-width: 992px) {
          font-size: 20px;
          margin-bottom: 30px;
        }
      }
    }
  }

  .text-content {
    display: flex;
    align-items: center;
    padding: 0;
    margin-bottom: 20px;
    @media (min-width: 992px) {
      padding: 20px;
      margin-bottom: 0;
    }
    text-align: center;
    width: 100%;
    @media (min-width: 992px) {
      width: auto;
      flex-grow: 1;
      flex-basis: 0;
    }
    div {
      width: 100%;

      ul {
        margin: 0;

        @media (min-width: 992px) {
          margin: 0 20px;
        }
        background: #000;
        padding: 10px;
        li {
          font-size: 13px;
          @media (min-width: 992px) {
            font-size: 17px;
          }
          font-weight: 600;
          text-align: left;
          padding: 15px;
          color: #fff;

          svg {
            margin-top: -3px;
          }
        }

        li.active {
          background: #fff;
          color: #000;
          border-radius: 3px;
        }
      }
    }
  }
`;

export const FinalBlock = styled.div`
  background: #000;
  padding: 20px;
  margin-bottom: 20px;

  @media (min-width: 992px) {
    padding: 40px;
  }

  .title {
    font-size: 24px;

    @media (min-width: 992px) {
      font-size: 34px;
    }

    margin-bottom: 20px;
    color: #fff;
    text-align: center;
    font-weight: 600;
  }
  .btn {
    text-align: center;
  }

  button {
    cursor: pointer;
    border-radius: 3px;
    padding: 8px 30px;
    background: linear-gradient(
        rgb(255, 255, 255) 0%,
        rgba(255, 255, 255, 0) 100%
      ),
      rgb(53, 70, 238);
    box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 4px;
    color: rgb(255, 255, 255);
    font-size: 14px;
    font-weight: 600;

    @media (min-width: 992px) {
      font-size: 18px;
      padding: 10px 40px;
    }
  }
`;

export const ApplyBlock = styled.div`
  background: #eceaea;
  padding: 20px;
  margin-bottom: 20px;

  @media (min-width: 992px) {
    padding: 40px;
  }

  .title {
    font-size: 24px;

    @media (min-width: 992px) {
      font-size: 34px;
    }

    margin-bottom: 20px;
    color: #000;
    text-align: center;
    font-weight: 600;
  }
  .btn {
    text-align: center;
  }

  button {
    cursor: pointer;
    border-radius: 3px;
    padding: 8px 30px;
    background: linear-gradient(
        rgb(255, 255, 255) 0%,
        rgba(255, 255, 255, 0) 100%
      ),
      rgb(53, 70, 238);
    box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 4px;
    color: rgb(255, 255, 255);
    font-size: 14px;
    font-weight: 600;
    border: none;

    @media (min-width: 992px) {
      font-size: 18px;
      padding: 10px 40px;
    }
  }
`;

export default PartnerSectionWrapper;
